/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UpdateApprovalCompetencyResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'ApprovalCompetency',
      },
    },
  }],
} as const;
